import { get } from '@bigyouth/base'

export default {
  name: 'custom-video',

  ui: {
    player: '[js-custom-video-player]',
    uiOverlay: '[js-custom-video-ui]',
    uiBg: '[js-custom-video-ui-bg]',
    uiPlayFirst: '[js-custom-video-ui-play]',
    uiPlayLabel: '[js-custom-video-ui-play-label]',
    uiSound: '[js-custom-video-ui-sound]',
    uiFullscreen: '[js-custom-video-ui-fullscreen]',
    uiPlayPause: '[js-custom-video-ui-play-pause]',
    uiSpeaker: '[js-custom-video-ui-speaker]',
    uiMute: '[js-custom-video-ui-mute]',
  },

  events: [
    {
      target: 'uiPlayFirst',
      on: 'click',
      handle () {
        this.isPlaying = !this.isPlaying

        this.ui.player.play()
        this.ui.uiOverlay.classList.add('is-playing')
      },
    },
    {
      target: 'uiPlayPause',
      on: 'click',
      handle () {
        this.isPlaying = !this.isPlaying

        if (this.isPlaying) {
          this.ui.player.play()
          this.ui.uiOverlay.classList.add('is-playing')
        } else {
          this.ui.player.pause()
          this.ui.uiOverlay.classList.remove('is-playing')
        }
      },
    },
    {
      target: 'uiSound',
      on: 'click',
      handle () {
        const srLabel = get('[data-other-label]', this.uiSound)
        this.switchSrLabel(srLabel)

        this.ui.player.muted = !this.ui.player.muted

        if (this.ui.player.muted) {
          this.ui.uiSpeaker.classList.add('hidden')
          this.ui.uiMute.classList.remove('hidden')
        } else {
          this.ui.uiSpeaker.classList.remove('hidden')
          this.ui.uiMute.classList.add('hidden')
        }
      },
    },
    {
      target: 'uiFullscreen',
      on: 'click',
      handle () {
        const srLabel = get('[data-other-label]', this.uiFullscreen)
        this.switchSrLabel(srLabel)

        if (this.ui.player.requestFullscreen) {
          this.ui.player.requestFullscreen()
        } else if (this.ui.player.mozRequestFullScreen) {
          this.ui.player.mozRequestFullScreen()
        } else if (this.ui.player.webkitRequestFullscreen) {
          this.ui.player.webkitRequestFullscreen()
        } else if (this.ui.player.msRequestFullscreen) {
          this.ui.player.msRequestFullscreen()
        }
      },
    },
  ],

  componentDidMount () {
    this.isPlaying = false
  },

  switchSrLabel (target) {
    const oldLabel = target.getAttribute('data-other-label')
    target.setAttribute('data-other-label', target.textContent)
    target.textContent = oldLabel
  },
}
